import { render, staticRenderFns } from "./DoubleSelectInfo.vue?vue&type=template&id=53d9e475&scoped=true&"
import script from "./DoubleSelectInfo.vue?vue&type=script&lang=js&"
export * from "./DoubleSelectInfo.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSelectInfo.vue?vue&type=style&index=0&id=53d9e475&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9e475",
  null
  
)

export default component.exports